import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 公共模块
export interface SupplierSmsCodeSendParams {
  enterpriseName: string
  mobile: string
}

export interface SupplierSmsLoginParams extends SupplierSmsCodeSendParams {
  code: string
}

export type LoginRes = {
  baseUrl: string
  code: string
  cooperateType: string
  enterpriseLevel: string
  enterpriseLevelName: string
  erpCode: string
  hasSupplierOrderAuthority: boolean
  mdmCode: string
  name: string
  realName: string
  role: string
  supplierId: string
  supplierUserId: string
  token: string
  isFirst: boolean
  menus: string[]
  permissionNameList: string[]
}

// 登录
export const POST_LOGIN_API = (params: SupplierSmsLoginParams) =>
  POST<LoginRes>(
    `${HTTP}/supplierUserLogin/supplierUserLogin`,
    params,
    'application/json',
    undefined,
    false,
  )

// 发送登录短信验证码
export const POST_LOGIN_SMS_CODE = (params: SupplierSmsCodeSendParams) =>
  POST<boolean>(
    `${HTTP}/supplierUserLogin/sendSmsCode`,
    params,
    'application/json',
    undefined,
    false,
  )

export type EnterpriseInfo = {
  corporate: string
  date: string
  enterpriseName: string
  id: string
  licenseUrl: string
  regAddress: string
  regCapital: string
  regStatus: string
  uscc: string
  cooperateType: string
}

// 工作台-企业信息
export const GET_HOMEDATA = (params: { supplierId: string }) =>
  GET<EnterpriseInfo>(`${HTTP}/workbench/getEnterpriseInfo`, params)

//	工作台-物料信息
export const GET_HOME_MATTER = (params: { supplierId: string }) =>
  GET(`${HTTP}/product/getMatterInfo`, params)

//	工作台-供应商信息
export const GET_HOME_SUPPLIER_ORDERCOUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/workbench/getOrderCount`, params)

interface PasswordParams {
  oldPassword: string
  newPwd: string
}
// 修改密码
export const UPDATEPASSWORD_API = (params: PasswordParams) =>
  POST(`${HTTP}/emptouser/doUpdatePwd`, params)

// 获取用户信息
export const GET_USER_INFO = () => GET(`${HTTP}/emptouser/userInfo`)

// 创建组织列表
export const GET_ORGANIZATION_API = (param: {
  canBeShipper?: '1' | '0' // 黑名单货主，1为不是，0为是
  canBeUseOrg?: '1' | '0' // 黑名单使用组织，1为不是，0为是
  code?: string // 编码
}) => GET(`${HTTP}/organization/list`, param)

// 获取任务类型下拉框（弹窗）数据
export const GET_TASKTYPE = () =>
  GET(`${HTTP}/batchTask/getBatchTaskTypeSelect`)

// 上级部门列表
export const GET_PARENTDEPARTMENT_API = (params: {
  pushState: string
  createcode: string
}) => GET(`${HTTP}/department/getDeptSelect`, params)

// 采购采购人员(连带部门)
export const GET_STAFF_API = (params: { deptId: string }) =>
  GET(`${HTTP}/erptojob/getEmpToJobList`, params)

// 刷新 采购人员
export const FETCH_PURCHASE_API = () => POST(`${HTTP}/emp/fetchPurchase`)

// 一次性获取tree
export const GET_TREEALLDATA_API = (params: { cooperateType: string }) =>
  GET(`${HTTP}/product/getCategoryTree`, params)

// 获取驳回理由列表
export const GET_REASONDATA_LIST = (params: { type: '1' | '2' }) =>
  GET(`${HTTP}/productAssessReason/list`, params)

// 新增驳回理由项
export const ADD_REASONDATA_LIST = (param: {
  content: string
  type: '1' | '2'
}) => POST(`${HTTP}/productAssessReason/add`, param)

// 删除驳回理由项
export const DEL_REASONDATA_LIST = (param: { id: string }) =>
  POST(`${HTTP}/productAssessReason/delete`, param)

// 获取对接平台列表
export const GET_ORDER_PLATFORM_LIST = () =>
  GET(`${HTTP}/order/getOrderPlatformList`)

// 根据供应商id获取供应商的可接单平台 - 包含项目字段信息
export const GET_PLATFORM_FIELD = (param: { supplierId: string }) =>
  GET(`${HTTP}/supplier/platformAndItemField`, param)

// 获取区域
export const GET_AREA = () => GET(`${HTTP}/product/getAllProvinceCity`)

// 待办事项清单参数
export interface TodoListParam {
  pageNo?: number
  pageSize?: number
  supplierId: string
  title?: string // 待办标题
  creatorName?: string // 创建人名称
  startCreatedTime?: number // 创建时间-开始
  endCreatedTime?: number // 创建时间-结束
  startDeadlineTime?: number // 截止时间-开始
  endDeadlineTime?: number // 截止时间-结束
  siftTab: string // 筛选tab：1、当前待办，2、已完结
}

export interface TodoListRes {
  id: string // id
  title: string // 待办标题
  businessId: string // 关联的代办业务id
  category: string // 分类：1-询价单，21-物料驳回，22-品牌驳回，31-需发货，32-需上传凭证，33-凭证驳回，34-开票(待开发票)，35-发票驳回(电商)，36-开票(发票录入)，41-待接单，42-取消订货确认，43-发票驳回(自营)
  priority: string // 优先级：1：常规、2：紧急
  status: string // 状态：1：待处理、2：逾期、3：已完成
  visibilityScope: string // 可见范围：ALL-自营供应商都可见可见, SPECIFIC-指定账号可见
  createdTime: number // 创建时间：时间戳
  deadlineTime: number // 截止时间：时间戳
  completedTime: number // 待办完成时间：时间戳，记录待办状态变为已完成的时间
  creatorName: string // 创建人姓名（冗余）
  handlerId: string // 处理人：前台供应商账号
  handlerName: string // 处理人姓名（冗余）
  updatedTime: number // 更新时间戳
  state: string // 状态：0-删除 1-正常
  jumpParams?: string // 跳转参数JSON字符串，部分category需要后端提供额外跳转参数
}
// 获取待办事项清单
export const GET_TODOLIST = (param: TodoListParam) =>
  GET(`${HTTP}/todoBusiness/page`, param)

interface TodoListCountParam {
  currentToDoCount: string // 待办数量
  finishedCount: string // 已完结数量
}
// 获取当前待办数量
export const GET_TODOLIST_COUNT = (param: { supplierId: string }) =>
  GET(`${HTTP}/todoBusiness/countPage`, param)

export type PermissionList =
  | '我的物料'
  | '电供客户订单'
  | '我的询价单'
  | '咸亨订单'
// 获取工作台看板权限
export const GET_WORKBENCH_PERMISSION = (param: { supplierId: string }) =>
  GET<PermissionList[]>(`${HTTP}/product/getWorkBenchPermission`, param)

// 获取工作台我的物料
export const GET_WORKBENCH_MATTER = (param: { supplierId: string }) =>
  GET<WorkBenchProductDTO>(`${HTTP}/product/getMatterInfoNew`, param)

export interface WorkBenchProductDTO {
  totalCount: number // 我的物料数量
  examineProductCount: number // 审核中物料
  rejectedBrandCount: number // 驳回的品牌数量
  rejectedProductCount: number // 驳回的物料数量
}

// 电供客户订单
export const GET_WORKBENCH_CUSTOMER_ORDER = (param: { supplierId: string }) =>
  GET<WorkBenchCustomerOrderDTO>(
    `${HTTP}/order/getWorkBenchCustomerOrder`,
    param,
  )

export interface WorkBenchCustomerOrderDTO {
  totalCount: number // 订单总数
  beShippedCount: number // 待发货订单数量
  beAcceptedCount: number // 待验收订单数量
  beInvoicedCount: number // 待开票订单数量
  beCollectedCount: number // 待收款订单数量
  shipmentOverdueCount: number // 发货超期订单数量
  properOverdueCount: number // 妥投超期订单数量
}

// 工作台-我的询价单
export const GET_WORKBENCH_INQUIRY = (param: { supplierId: string }) =>
  GET<WorkBenchInquiryDTO>(`${HTTP}/inquiry/getWorkBenchInquiry`, param)

export interface WorkBenchInquiryDTO {
  totalCount: number // 询价单总数
  bePendingCount: number // 待接单数量
  beQuotedCount: number // 待报价数量
}

// 工作台-咸亨订单
export const GET_WORKBENCH_XH_ORDER = (param: { supplierId: string }) =>
  GET<WorkBenchXhOrderDTO>(`${HTTP}/supplierOrder/getWorkBenchXhOrder`, param)

export interface WorkBenchXhOrderDTO {
  totalCount: number // 订单总数
  bePendingCount: number // 待接单订单数量
  beShippedCount: number // 待发货订单数量
}

// 供应商点击待办后自动完成，适用于阅即完成类待办
export const COMPLETE_TODO = (param: { todoId: string }) =>
  GET(`${HTTP}/todoBusiness/completeTodo`, param)
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 公共模块
export interface SupplierSmsCodeSendParams {
  enterpriseName: string
  mobile: string
}

export interface SupplierSmsLoginParams extends SupplierSmsCodeSendParams {
  code: string
}

export type LoginRes = {
  baseUrl: string
  code: string
  cooperateType: string
  enterpriseLevel: string
  enterpriseLevelName: string
  erpCode: string
  hasSupplierOrderAuthority: boolean
  mdmCode: string
  name: string
  realName: string
  role: string
  supplierId: string
  supplierUserId: string
  token: string
  isFirst: boolean
  menus: string[]
  permissionNameList: string[]
}

// 登录
export const POST_LOGIN_API = (params: SupplierSmsLoginParams) =>
  POST<LoginRes>(
    `${HTTP}/supplierUserLogin/supplierUserLogin`,
    params,
    'application/json',
    undefined,
    false,
  )

// 发送登录短信验证码
export const POST_LOGIN_SMS_CODE = (params: SupplierSmsCodeSendParams) =>
  POST<boolean>(
    `${HTTP}/supplierUserLogin/sendSmsCode`,
    params,
    'application/json',
    undefined,
    false,
  )

export type EnterpriseInfo = {
  corporate: string
  date: string
  enterpriseName: string
  id: string
  licenseUrl: string
  regAddress: string
  regCapital: string
  regStatus: string
  uscc: string
  cooperateType: string
}

// 工作台-企业信息
export const GET_HOMEDATA = (params: { supplierId: string }) =>
  GET<EnterpriseInfo>(`${HTTP}/workbench/getEnterpriseInfo`, params)

//	工作台-物料信息
export const GET_HOME_MATTER = (params: { supplierId: string }) =>
  GET(`${HTTP}/product/getMatterInfo`, params)

//	工作台-供应商信息
export const GET_HOME_SUPPLIER_ORDERCOUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/workbench/getOrderCount`, params)

interface PasswordParams {
  oldPassword: string
  newPwd: string
}
// 修改密码
export const UPDATEPASSWORD_API = (params: PasswordParams) =>
  POST(`${HTTP}/emptouser/doUpdatePwd`, params)

// 获取用户信息
export const GET_USER_INFO = () => GET(`${HTTP}/emptouser/userInfo`)

// 创建组织列表
export const GET_ORGANIZATION_API = (param: {
  canBeShipper?: '1' | '0' // 黑名单货主，1为不是，0为是
  canBeUseOrg?: '1' | '0' // 黑名单使用组织，1为不是，0为是
  code?: string // 编码
}) => GET(`${HTTP}/organization/list`, param)

// 获取任务类型下拉框（弹窗）数据
export const GET_TASKTYPE = () =>
  GET(`${HTTP}/batchTask/getBatchTaskTypeSelect`)

// 上级部门列表
export const GET_PARENTDEPARTMENT_API = (params: {
  pushState: string
  createcode: string
}) => GET(`${HTTP}/department/getDeptSelect`, params)

// 采购采购人员(连带部门)
export const GET_STAFF_API = (params: { deptId: string }) =>
  GET(`${HTTP}/erptojob/getEmpToJobList`, params)

// 刷新 采购人员
export const FETCH_PURCHASE_API = () => POST(`${HTTP}/emp/fetchPurchase`)

// 一次性获取tree
export const GET_TREEALLDATA_API = (params: { cooperateType: string }) =>
  GET(`${HTTP}/product/getCategoryTree`, params)

// 获取驳回理由列表
export const GET_REASONDATA_LIST = (params: { type: '1' | '2' }) =>
  GET(`${HTTP}/productAssessReason/list`, params)

// 新增驳回理由项
export const ADD_REASONDATA_LIST = (param: {
  content: string
  type: '1' | '2'
}) => POST(`${HTTP}/productAssessReason/add`, param)

// 删除驳回理由项
export const DEL_REASONDATA_LIST = (param: { id: string }) =>
  POST(`${HTTP}/productAssessReason/delete`, param)

// 获取对接平台列表
export const GET_ORDER_PLATFORM_LIST = () =>
  GET(`${HTTP}/order/getOrderPlatformList`)

// 根据供应商id获取供应商的可接单平台 - 包含项目字段信息
export const GET_PLATFORM_FIELD = (param: { supplierId: string }) =>
  GET(`${HTTP}/supplier/platformAndItemField`, param)

// 获取区域
export const GET_AREA = () => GET(`${HTTP}/product/getAllProvinceCity`)

// 待办事项清单参数
export interface TodoListParam {
  pageNo?: number
  pageSize?: number
  supplierId: string
  title?: string // 待办标题
  creatorName?: string // 创建人名称
  startCreatedTime?: number // 创建时间-开始
  endCreatedTime?: number // 创建时间-结束
  startDeadlineTime?: number // 截止时间-开始
  endDeadlineTime?: number // 截止时间-结束
  siftTab: string // 筛选tab：1、当前待办，2、已完结
}

export interface TodoListRes {
  id: string // id
  title: string // 待办标题
  businessId: string // 关联的代办业务id
  category: string // 分类：1-询价单，21-物料驳回，22-品牌驳回，31-需发货，32-需上传凭证，33-凭证驳回，34-开票(待开发票)，35-发票驳回(电商)，36-开票(发票录入)，41-待接单，42-取消订货确认，43-发票驳回(自营)
  priority: string // 优先级：1：常规、2：紧急
  status: string // 状态：1：待处理、2：逾期、3：已完成
  visibilityScope: string // 可见范围：ALL-自营供应商都可见可见, SPECIFIC-指定账号可见
  createdTime: number // 创建时间：时间戳
  deadlineTime: number // 截止时间：时间戳
  completedTime: number // 待办完成时间：时间戳，记录待办状态变为已完成的时间
  creatorName: string // 创建人姓名（冗余）
  handlerId: string // 处理人：前台供应商账号
  handlerName: string // 处理人姓名（冗余）
  updatedTime: number // 更新时间戳
  state: string // 状态：0-删除 1-正常
  jumpParams?: string // 跳转参数JSON字符串，部分category需要后端提供额外跳转参数
}
// 获取待办事项清单
export const GET_TODOLIST = (param: TodoListParam) =>
  GET(`${HTTP}/todoBusiness/page`, param)

interface TodoListCountParam {
  currentToDoCount: string // 待办数量
  finishedCount: string // 已完结数量
}
// 获取当前待办数量
export const GET_TODOLIST_COUNT = (param: { supplierId: string }) =>
  GET(`${HTTP}/todoBusiness/countPage`, param)

export type PermissionList =
  | '我的物料'
  | '电供客户订单'
  | '我的询价单'
  | '咸亨订单'
// 获取工作台看板权限
export const GET_WORKBENCH_PERMISSION = (param: { supplierId: string }) =>
  GET<PermissionList[]>(`${HTTP}/product/getWorkBenchPermission`, param)

// 获取工作台我的物料
export const GET_WORKBENCH_MATTER = (param: { supplierId: string }) =>
  GET<WorkBenchProductDTO>(`${HTTP}/product/getMatterInfoNew`, param)

export interface WorkBenchProductDTO {
  totalCount: number // 我的物料数量
  examineProductCount: number // 审核中物料
  rejectedBrandCount: number // 驳回的品牌数量
  rejectedProductCount: number // 驳回的物料数量
}

// 电供客户订单
export const GET_WORKBENCH_CUSTOMER_ORDER = (param: { supplierId: string }) =>
  GET<WorkBenchCustomerOrderDTO>(
    `${HTTP}/order/getWorkBenchCustomerOrder`,
    param,
  )

export interface WorkBenchCustomerOrderDTO {
  totalCount: number // 订单总数
  beShippedCount: number // 待发货订单数量
  beAcceptedCount: number // 待验收订单数量
  beInvoicedCount: number // 待开票订单数量
  beCollectedCount: number // 待收款订单数量
  shipmentOverdueCount: number // 发货超期订单数量
  properOverdueCount: number // 妥投超期订单数量
}

// 工作台-我的询价单
export const GET_WORKBENCH_INQUIRY = (param: { supplierId: string }) =>
  GET<WorkBenchInquiryDTO>(`${HTTP}/inquiry/getWorkBenchInquiry`, param)

export interface WorkBenchInquiryDTO {
  totalCount: number // 询价单总数
  bePendingCount: number // 待接单数量
  beQuotedCount: number // 待报价数量
}

// 工作台-咸亨订单
export const GET_WORKBENCH_XH_ORDER = (param: { supplierId: string }) =>
  GET<WorkBenchXhOrderDTO>(`${HTTP}/supplierOrder/getWorkBenchXhOrder`, param)

export interface WorkBenchXhOrderDTO {
  totalCount: number // 订单总数
  bePendingCount: number // 待接单订单数量
  beShippedCount: number // 待发货订单数量
}

// 供应商点击待办后自动完成，适用于阅即完成类待办
export const COMPLETE_TODO = (param: { todoId: string }) =>
  GET(`${HTTP}/todoBusiness/completeTodo`, param)
